var ProjectStatuses = require('./gen/project_statuses');

/**
 * This is for compatibility reasons. Please use createInProject.
 */
ProjectStatuses.prototype.create = ProjectStatuses.prototype.createInProject;

module.exports = ProjectStatuses;



//////////////////
// WEBPACK FOOTER
// ./node_modules/asana/lib/resources/project_statuses.js
// module id = 1458
// module chunks = 0